var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './sidenav.css';
var SideNav = /** @class */ (function (_super) {
    __extends(SideNav, _super);
    function SideNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SideNav.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: 'col-xs-2 collection-nav__container' },
                React.createElement("ul", { className: 'collection-nav' },
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/Mens"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, " Mens ")),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/Womens"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, " Womens ")),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/feed"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, "News Feed")),
                    React.createElement("li", { className: 'collection-nav__separator' }, "\u00A0"),
                    React.createElement("li", { className: 'collection-nav__item' },
                        React.createElement(NavLink, { to: "/collection/Sweaters" },
                            React.createElement("a", { className: 'collection-nav__link' }, "Sweaters "))),
                    React.createElement("li", { className: 'collection-nav__item' },
                        React.createElement(NavLink, { to: "/collection/Coats" },
                            React.createElement("a", { className: 'collection-nav__link' }, "Coats"))),
                    React.createElement("li", { className: 'collection-nav__item' },
                        React.createElement(NavLink, { to: "/collection/Denim" },
                            React.createElement("a", { className: 'collection-nav__link' }, "Denim"))),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/Dress"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, "Dress")),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/T-shirts"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, "T-Shirts")),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/Shirts"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link' }, "Dress Shirts & Polos")),
                    React.createElement("li", { onClick: function () { return _this.props.goTo("/collection/Shorts"); }, className: 'collection-nav__item' },
                        React.createElement("a", { className: 'collection-nav__link collection-nav__link--active' }, "Shorts"),
                        React.createElement("ul", { className: 'collection-nav__subcategories' }))))));
    };
    return SideNav;
}(Component));
var mapStateToProps = function (state, ownProps) {
    var userId = state.getIn(['authorize', 'uid'], {});
    return {
        userId: userId
    };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        goTo: function (url) { return dispatch(push(url)); }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
// export default SideNav



//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/sidenav.tsx
// module id = 1574
// module chunks = 1 6 21 23